import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import Login from './components/Login';
import DevLogin from './components/DevLogin';
import Home from './components/Home';
import Survey from './components/Survey';
import EditResponses from './components/EditResponses';
import Confirmation from './components/Confirmation';
import AdminDashboard from './components/AdminDashboard';
import TripDetails from './components/TripDetails';
import Carpools from './components/Carpools';
import LodgingBeds from './components/LodgingBeds';
import Profile from './components/Profile';
import Social from './components/Social';
import PwaInstallPrompt from './components/PwaInstallPrompt';
import Footer from './components/Footer';
import './App.css';

function App() {
  const [useDevMode, setUseDevMode] = useState(false);

  useEffect(() => {
    // Check if we should use dev mode (when Firebase auth fails)
    const checkDevMode = () => {
      if (localStorage.getItem('devMode') === 'true') {
        setUseDevMode(true);
      }
    };
    
    checkDevMode();
    
    // Listen for Firebase auth errors
    const handleError = (event) => {
      if (event.error && event.error.message && event.error.message.includes('Firebase')) {
        setUseDevMode(true);
      }
    };
    
    window.addEventListener('error', handleError);
    return () => window.removeEventListener('error', handleError);
  }, []);

  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/" element={useDevMode ? <DevLogin /> : <Login />} />
              <Route path="/login" element={useDevMode ? <DevLogin /> : <Login />} />
              <Route path="/home" element={<Home />} />
              <Route path="/survey" element={<Survey />} />
              <Route path="/edit-responses" element={<EditResponses />} />
              <Route path="/confirmation" element={<Confirmation />} />
              <Route path="/trip-details" element={<TripDetails />} />
              <Route path="/trip-details/lodging-beds" element={<LodgingBeds />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/carpools" element={<Carpools />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/social" element={<Social />} />
            </Routes>
            <PwaInstallPrompt />
            <Footer />
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
